module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Cocoa Closed.bd0e376b.png";